import styled from '@emotion/styled'
import { Container, Grid, useTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Heading, P, SectionHeading, SectionSmallHeading, SectionWrapper } from '../../Styles/style'
import copy from "../../../assets/images/copy.png"

import DoneAllIcon from '@mui/icons-material/DoneAll';
const DIv = styled.div`
  position: relative;
`
const Value = styled.p`
color: #fff;
position: absolute;
    /* top: 29px; */
    left: 70px;
    @media screen and (max-width:1199px){
        bottom: 29px;
        left: 70px;
        font-size: 12px;
    }
`
const Grids = styled(Grid)`
`

const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 12px 20px;
border-radius: 5px;
margin-right: 15px;
display: flex;
align-items: center;

`
const Bdr = styled.div`
border-radius:8px;
padding:10px 20px 50px;
background-color: ${(props) => (props.bgColor ? props.bgColor : "#0f0f3658")};
`;
const Ca = styled.div`
border-radius:8px;
padding:0px 20px;
display:flex;
justify-content:space-between;
align-items:center;
background-color: ${(props) => (props.bgColor ? props.bgColor : "#0f0f3658")};
@media screen and (max-width: 450px) {
    /* display:grid; */
 }
 `;
 
 const Textarea = styled.textarea`
 font-size: 20px;
 resize: none;
font-family: "P-SB";
 overflow: hidden;
 color:#fff;
 border: none;
 width:530px;
 /* width:60px; */
 background: transparent;
 text-align: -webkit-center;
 text-align: -moz-center;
 outline: none;
 @media screen and (max-width: 800px) {
     width:UNSET;
 }
 `;
   const ContractAdd = styled.span`
 word-break: keep-all;
 
 padding:30px 0 0;
 display: flex;
 align-items: flex-start;
 
 `;
const S6_Tokenomics = () => {
    
  const [copySuccess, setCopySuccess] = useState("");
  const textAreaRef = useRef(null);
  

  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand("copy");
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    e.target.focus();
    setCopySuccess(<DoneAllIcon style={{fill:"#fff"}}/>);
  }
  useEffect(()=> {
    setTimeout(() => {
      setCopySuccess('')
    }, 2000)
},[copySuccess]);

    const theme = useTheme()
    return (
        <div>
            <SectionWrapper p="4rem 0" id="tokenomics">
                <Container maxWidth="xl">
                    <SectionHeading    fs="70px" align="left" p="40px 0" m="0" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="500"
                        data-aos-duration="500"
                        data-aos-offset="0">Coin Info</SectionHeading>
                    <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                        <Grids item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Bdr>

                                <Heading>Name</Heading>
                                <SectionSmallHeading align="left" p="10PX 0 0" m="0" tt="none" >Pulse Pepe</SectionSmallHeading>
                            </Bdr>
                        </Grids>
                        <Grids item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Bdr>

                                <Heading>Symbol</Heading>
                                <SectionSmallHeading align="left" p="10PX 0 0" m="0" tt="none" >$PPEPE</SectionSmallHeading>
                            </Bdr>
                        </Grids>
                        <Grids item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Bdr>

                                <Heading>Supply</Heading>
                                <SectionSmallHeading align="left" p="10PX 0 0" m="0" tt="none" >420,690,000,000,000</SectionSmallHeading>
                            </Bdr>
                        </Grids>
                        <Grids item xs={12} md={3} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Bdr>

                                <Heading>Taxes</Heading>
                                <SectionSmallHeading align="left" p="10PX 0 0" m="0" tt="none" >2/2</SectionSmallHeading>
                            </Bdr>
                        </Grids>
                        <Grids item xs={12} md={12} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Ca bgColor="#F5063F">

                                <Heading>Contract</Heading>
                                <ContractAdd>
                                    <Textarea ref={textAreaRef} value="0x64d3799fe6E5e833996752c252A141F2Cfe7EaA9" />
                                    <img
                                        onClick={copyToClipboard}
                                        style={{ cursor: "pointer" }}
                                        src={copy}
                                    />
                                    {copySuccess}
                                </ContractAdd>
                              
                            </Ca>
                        </Grids>

                    </Grid>
                </Container>
            </SectionWrapper>
        </div>
    )
}

export default S6_Tokenomics